module.exports = __webpack_public_path__ + "static/img/Silver IV.d67b1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Silver IV.png
// module id = Ffni
// module chunks = 38